import moment from "moment";
import {
  Alert,
  Button,
  Card,
  Typography,
  notification,
  Table,
  Modal,
  message,
  Collapse,
  Input,
  Flex,
  Popconfirm,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchSTBusinessUnits,
  fetchSTCampaigns,
  organization_custom_booking_url,
} from "../../redux/organizationSlice";

import Step1Panel from "./panels/Step1Panel";
import Step2Panel from "./panels/Step2Panel";
import Step3Panel from "./panels/Step3Panel";
import CustomCssTransition from "../../components/UI/CustomCssTransition/customCssTransition";
import axiosInstance from "../../redux/apiAxios";

import { LinkOutlined, EditFilled, DeleteFilled, CloseOutlined }
from "@ant-design/icons";
import { MAX_ALLOWED_QUESTIONS, MAX_ALLOWED_ANSWERS } from "../../utils/constants";

import "./CustomUrl.css";

const { Title } = Typography;
const { Panel } = Collapse;

const initialDispatchFeeDetails = {
  dispatch_fee: 0,
  member_dispatch_fee: 0,
  use_default_dispatch: true,
  member_is_active: true,
};

export default function GenerateCustomURL() {
  const {
    organizationData,
    serviceTitanBusinessUnits,
    serviceTitanJobs,
    serviceTitanJobTags,
    serviceTitanCampaigns
  } = useSelector((state) => state.organization);
  const [campaignName, setCampaignName] = useState("");
  const [generatedURLs, setGeneratedURLs] = useState([]);
  const [selectedBu, setSelectedBu] = useState(null);
  const [selectedJobType, setSelectedJobType] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [urlcode, seturlcode] = useState(0);
  const [additionalInfo, setAdditionalInfo] = useState(true);
  const [isdispatchFee, setIsDispatchFee] = useState(false);
  const [isMemberFee , setIsMemberFee] = useState(false)
  const [customerType, setCustomerType] = useState("Existing Customer");
  const [dispatchDetails, setDispatchDetails] = useState(
    {}
  );
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [tagIds, setTagIds] = useState([]);
  const [updateModal, setUpdateModal] = useState(false);
  const [pageSize,setpageSize] = useState(5);
  const [tableLoading, setTableLoading] = useState(false);
  const [urlQuestions, setUrlQuestions] = useState([]);
  const [thankYouPage, setThankYouPage] = useState({
    enabled: false,
    url: "",
  });
  const [urlMode, setUrlMode] = useState("campaign_tracking");

  const dispatch = useDispatch();

  const columns = [
    {
      title: "Date",
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (text) => (
        <span style={{ color: "#6b7280" }}>{text}</span>
      ),
    },
    {
      title: "Campaign Name",
      dataIndex: "campaignName",
      key: "campaignName",
      render: (text) => (
        <span style={{ fontWeight: "600", color: "#6b7280" }}>{text}</span>
      ),
    },
    {
      title: "Type",
      key: "type",
      render: (_, record) => {
        const orgProvider = organizationData?.organization_provider || "ST";
        const isJobBooking =
          orgProvider === "HCP"
            ? !!record.jobType
            : !!(record.buId && record.jobType);
        return (
          <span style={{ color: "#6b7280", fontSize: "13px" }}>
            {isJobBooking ? "Single Job Mode" : "Full Scheduler Mode"}
          </span>
        );
      },
    },
    {
      title: "Generated URL",
      dataIndex: "customUrl",
      key: "customUrl",
      render: (text) => (
        <a
          href={text}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#3b82f6",
            display: "block",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 600,
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "16px" }}>
          <Tooltip title="Edit">
            <EditFilled
              style={{ 
                fontSize: 20, 
                color: "#1890ff",
                cursor: "pointer"
              }}
              onClick={() => {
                seturlcode(record.urlCode);
                setCampaignName(record.campaignName);
                setCustomerType(record.customerType);
                setSelectedCampaign(record.campaignData);
                const orgProvider = organizationData?.organization_provider || "ST";
                const hasExistingJob =
                  orgProvider === "HCP"
                    ? !!record.jobType
                    : !!(record.buId && record.jobType);
                setUrlMode(hasExistingJob ? "job_booking" : "campaign_tracking");
                setSelectedBu(record.buId);
                setSelectedJobType(record.jobType);
                setTagIds(record.tagIds);
                setAdditionalInfo(record.additionalInfo);
                setIsDispatchFee(record.dispatchFee);
                setIsMemberFee(record.member_dispatch_fee);
                setDispatchDetails(record.dispatchFeeDetails);
                setThankYouPage({
                  enabled: record.thankYouPage?.enabled || false,
                  url: record.thankYouPage?.url || "",
                });
                const incoming = record.urlQuestions || [];
                const normalized = incoming.map((q) => {
                  const optionsArray = Array.isArray(q?.options)
                    ? q.options.map((o) =>
                        typeof o === "string" ? { option: o } : { option: o?.option || "" }
                      )
                    : q?.answer
                    ? [{ option: q.answer }]
                    : [];
                  return { question: q?.question || "", options: optionsArray };
                });
                setUrlQuestions(normalized);
                setUpdateModal(true);
                setIsModalVisible(true);
              }}
            />
          </Tooltip>
          <Popconfirm
            title="Delete Custom URL"
            description="Are you sure you want to delete this custom URL?"
            onConfirm={() => handleDeleteCustomURL(record.urlCode)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <DeleteFilled
                style={{ 
                  fontSize: 20, 
                  color: "#ff4d4f",
                  cursor: "pointer"
                }}
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];
  

  const provider = organizationData?.organization_provider || "ST";
  const hasJobContext =
    urlMode === "job_booking" &&
    (provider === "HCP"
      ? !!selectedJobType
      : !!(selectedBu && selectedJobType));

  useEffect(() => {
    if (urlMode === "campaign_tracking") {
      setSelectedBu(null);
      setSelectedJobType(null);
    }
  }, [urlMode]);

  useEffect(() => {
    if (urlMode === "campaign_tracking") {
      setIsDispatchFee(false);
      setDispatchDetails({
        ...initialDispatchFeeDetails,
        dispatch_header: organizationData?.default_dispatch_header,
        dispatch_body: organizationData?.default_dispatch_body,
        dispatch_text: organizationData?.default_dispatch_text,
      });
      setUrlQuestions([]);
    }
  }, [
    urlMode,
    organizationData?.default_dispatch_header,
    organizationData?.default_dispatch_body,
    organizationData?.default_dispatch_text,
  ]);

  useEffect(() => {
    const orgId = organizationData?._id;
    if (orgId) {
      dispatch(fetchSTCampaigns(orgId));
      dispatch(fetchSTBusinessUnits(orgId));
      async function fetchCustomURL() {
        setTableLoading(true);
        try {
          const response = await axiosInstance.get(
            `/org/fetch/customurl/${orgId}`
          );
          setGeneratedURLs(response?.data || []);
        } catch (error) {
          console.error('Error fetching custom URLs:', error);
          setGeneratedURLs([]);
        } finally {
          setTableLoading(false);
        }
      }
      void fetchCustomURL();
    }
  }, [dispatch, organizationData?._id]);

  useEffect(() => {
    if (isModalVisible && organizationData?._id) {
      dispatch(fetchSTBusinessUnits(organizationData._id));
    }
  }, [isModalVisible, organizationData?._id, dispatch]);

  const generateRandomDigitNumber = () => {
    const existingCodes = new Set((generatedURLs || []).map((u) => u.urlCode));
    let candidate = "";
    let guard = 0;
    do {
      candidate = Math.floor(Math.random() * 10000).toString();
      guard += 1;
    } while (existingCodes.has(candidate) && guard < 50);
    return candidate;
  };

  const handleDeleteCustomURL = async (urlCode) => {
    try {  
      await axiosInstance.delete(`/org/register/customurl/${organizationData?._id}/${urlCode}`,);
      
      const updatedURLs = generatedURLs.filter(url => url.urlCode !== urlCode);
      setGeneratedURLs(updatedURLs);
      
      messageApi.success({
        type: "success",
        content: "Custom URL deleted successfully.",
      });
    } catch (error) {
      console.error('Error deleting custom URL:', error);
      notification.error({
        message: "Error",
        description: "Failed to delete custom URL.",
        duration: 3,
      });
    }
  };

  const generateCustomURL = () => {
    if (!campaignName) {
      notification.error({
        message: "Error",
        description: "Please enter a campaign name.",
        duration: 3,
      });
      return;
    }

    if (urlMode === "job_booking") {
      const missingJob =
        provider === "HCP"
          ? !selectedJobType
          : !selectedBu || !selectedJobType;
      if (missingJob) {
        notification.error({
          message: "Error",
          description:
            provider === "HCP"
              ? "Please select a Job Type for Single Job mode."
              : "Please select Business Unit and Job Type for Single Job mode.",
          duration: 3,
        });
        return;
      }
    }

    if (thankYouPage.enabled && !thankYouPage.url.trim()) {
      notification.error({
        message: "Error",
        description: "Please enter the Thank You page URL.",
        duration: 3,
      });
      return;
    }

    if (urlQuestions.length > MAX_ALLOWED_QUESTIONS) {
      notification.error({
        message: "Error",
        description: `You can add at most ${MAX_ALLOWED_QUESTIONS} questions.`,
        duration: 3,
      });
      return;
    }

    for (let i = 0; i < urlQuestions.length; i++) {
      const q = urlQuestions[i];
      if (!q.question || q.question.trim() === "") {
        notification.error({
          message: "Validation Error",
          description: `Question ${i + 1} cannot be empty.`,
          duration: 3,
        });
        return;
      }
      const options = Array.isArray(q.options) ? q.options : [];
      if (options.length < 2) {
        notification.error({
          message: "Validation Error",
          description: `Question ${i + 1} must have at least two answers/options.`,
          duration: 3,
        });
        return;
      }
      if (options.length > MAX_ALLOWED_ANSWERS) {
        notification.error({
          message: "Validation Error",
          description: `Question ${i + 1} can have at most ${MAX_ALLOWED_ANSWERS} answers/options.`,
          duration: 3,
        });
        return;
      }
      const trimmed = options.map((o) => (o?.option || "").trim()).filter(Boolean);
      if (trimmed.length !== options.length) {
        notification.error({
          message: "Validation Error",
          description: `All answers for Question ${i + 1} must be non-empty.`,
          duration: 3,
        });
        return;
      }
      const unique = new Set(trimmed);
      if (unique.size !== trimmed.length) {
        notification.error({
          message: "Validation Error",
          description: `Answers for Question ${i + 1} must be unique.`,
          duration: 3,
        });
        return;
      }
    }

    const customUrlCode = updateModal ? urlcode : generateRandomDigitNumber();

    const url = new URL(organizationData?.organization_webAddress);
    url.searchParams.append("c", customUrlCode);
    const newEntry = {
      organizationId: organizationData._id,
      dateCreated: moment().format("ddd, DD YYYY"),
      urlCode: customUrlCode,
      customerType: customerType,
      campaignName: campaignName,
      buId: selectedBu,
      jobType: selectedJobType,
      tagIds: tagIds,
      customUrl: url.toString(),
      additionalInfo: additionalInfo,
      dispatchFee: hasJobContext ? isdispatchFee : false,
      dispatchFeeDetails:
        hasJobContext && isdispatchFee
          ? dispatchDetails
          : {
              ...initialDispatchFeeDetails,
              dispatch_header: organizationData?.default_dispatch_header,
              dispatch_body: organizationData?.default_dispatch_body,
              dispatch_text: organizationData?.default_dispatch_text,
            },
      campaignData: selectedCampaign,
      urlQuestions: hasJobContext ? urlQuestions : [],
      thankYouPage: thankYouPage,
    };
    try {
      dispatch(
        organization_custom_booking_url({
          id: organizationData._id,
          payload: newEntry,
        })
      );
      if (updateModal) {
        const index = generatedURLs.findIndex(
          (item) => item.urlCode === customUrlCode
        );
        generatedURLs[index] = newEntry;
        setGeneratedURLs([...generatedURLs]);
      } else {
        setGeneratedURLs([ newEntry,...generatedURLs]);
      }

      navigator.clipboard
        .writeText(url.toString())
        .then(() => {
          messageApi.success({
            type: "success",
            content: "URL copied to clipboard.",
          });
        })
        .catch(() => {
          messageApi.error({
            type: "error",
            content: "Failed to copy URL to clipboard.",
          });
        });
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to generate custom URL.",
        duration: 3,
      });
    } finally {
      setIsModalVisible(false);
    }
  };

  const handleDispatchTextChange = (value, jobItemId) => {
    const key = Object.keys(value)[0];
    if(key === "member_is_active"){
      setDispatchDetails((prev) => ({
        ...prev,
        [key]: value[key],
        dispatch_body: prev?.dispatch_body,
        dispatch_header: prev?.dispatch_header,
        dispatch_text: prev?.dispatch_text,
      }));
    }
    setDispatchDetails((prev) => ({ ...prev, [key]: value[key] }));
  };

  const filterOption = (input, option) =>{
    return ((option?.children || option?.label) ?? "").toLowerCase().includes(input.toLowerCase());

  }

 
	const CampaignsList =
		serviceTitanCampaigns?.map((item) => {
			return {
				value: item?.id,
				label: item?.name,
			};
		}) || [];

  return (
    <>
      {contextHolder}
      <Flex align="center" gap={10} style={{ marginBottom: "20px" }}>
      <LinkOutlined style={{ fontSize: 20 }} />
      <Title
       level={3} style={{ margin: 0 }}
      >
        Quick Booking Links
      </Title>

      </Flex>

      <div
        style={{
          padding: "24px",
          maxWidth: "100%",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "16px",
          }}
        >
          <Button
            type="default"
            style={{
              background: "rgb(4 42 87)",
              color: "#fff",
              fontSize:"12px",
              padding:"4px 12px",
              borderRadius: "5px",
              border: "none",
            }}
            onClick={() => {
              setCampaignName("");
              setCustomerType("Existing Customer");
              setSelectedCampaign(null);
              setSelectedBu(null);
              setSelectedJobType(null);
              setTagIds([]);
              setAdditionalInfo(false);
              setIsDispatchFee(false);
              setUrlMode("campaign_tracking");
              setDispatchDetails({
                ...initialDispatchFeeDetails,
                dispatch_header: organizationData?.default_dispatch_header,
                dispatch_body: organizationData?.default_dispatch_body,
                dispatch_text: organizationData?.default_dispatch_text,
              });
              setThankYouPage({ enabled: false, url: "" });
              setUpdateModal(false);
              setUrlQuestions([]);
              setIsModalVisible(true);
            }}
          >
            Generate New Link
          </Button>
        </div>

        <Card
          bordered={false}
          style={{
            width: "100%",
            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
            borderRadius: "10px",
          }}
        >
          <Table
            dataSource={generatedURLs}
            columns={columns}
            rowKey="urlCode"
            loading={tableLoading}
            pagination={{
              defaultPageSize:5,
              pageSize: pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ['5', '10', '20', '50'],  
            }} 
            onChange={(pagination) => {
              setpageSize(pagination?.pageSize ?? 5)
            }}
            style={{ marginTop: "16px" }}
          />
        </Card>
      </div>

      <Modal
        className="custom-url-modal"
        title={
          updateModal
            ? "Update Custom Booking URL"
            : "Generate Custom Booking URL"
        }
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => setIsModalVisible(false)}
            style={{
              fontSize:"12px",
              padding:"4px 12px",
              borderRadius: "5px",
              color: "#6b7280",
            }}
          >
            Cancel
          </Button>,
          <Button
            key="generate"
            type="primary"
            onClick={generateCustomURL}
            style={{
              backgroundColor: "rgb(4 42 87)",
              fontSize:"12px",
              padding:"4px 12px",
              borderRadius: "5px",
              border: "none",
            }}
          >
            {updateModal ? "Update Link" : "Generate Link"}
          </Button>,
        ]}
        width={800}
      >
        <div className="custom-url-mode-section">
          <span className="custom-url-mode-label">
            What type of link do you want to create?
          </span>
          <p className="custom-url-mode-label-desc">
            Choose based on how you plan to use this link.
          </p>
          <div className="custom-url-mode-options">
            <div
              className={`custom-url-mode-card ${urlMode === "campaign_tracking" ? "active" : ""}`}
              onClick={() => setUrlMode("campaign_tracking")}
              onKeyDown={(e) => e.key === "Enter" && setUrlMode("campaign_tracking")}
              role="button"
              tabIndex={0}
            >
              <div className="custom-url-mode-card-title">Full Scheduler Mode</div>
              <div className="custom-url-mode-card-desc">
                Create a booking link that opens the full scheduler, but maps to a specific ST campaign.
              </div>
            </div>
            <div
              className={`custom-url-mode-card ${urlMode === "job_booking" ? "active" : ""}`}
              onClick={() => setUrlMode("job_booking")}
              onKeyDown={(e) => e.key === "Enter" && setUrlMode("job_booking")}
              role="button"
              tabIndex={0}
            >
              <div className="custom-url-mode-card-title">Single Job Mode</div>
              <div className="custom-url-mode-card-desc">
                Create a booking link that maps to a single job type, with a variety of customizations.
              </div>
            </div>
          </div>
          {/* <Alert
            message={
              urlMode === "campaign_tracking"
                ? "ServiceTitan campaign attribution only — customers will select their job in the scheduler."
                : "Job booking + ServiceTitan campaign attribution — customers go straight to scheduling."
            }
            type="info"
            showIcon
            className="custom-url-mode-alert"
          /> */}
        </div>

        <Collapse defaultActiveKey={["1", "2", "3", "4", "5"]} className="custom-url-panel">
          <Panel header="Step 1: Campaign Name" key="1">
            <div className="custom-url-campaign-name-group">
              <label className="custom-url-field-label">
              Campaign Name

              </label>
              <Input
                placeholder="e.g., Google Ads - Plumbing"
                onChange={(e) => setCampaignName(e.target.value)}
                value={campaignName}
                style={{ borderRadius: "8px" }}
              />
            </div>
          </Panel>
          <Panel
            header={urlMode === "job_booking" ? "Step 2: Job Booking Details" : "Step 2: Campaign & Tags"}
            key="2"
          >
            <Step1Panel
              serviceTitanBusinessUnits={serviceTitanBusinessUnits}
              serviceTitanJobs={serviceTitanJobs}
              selectedCampaign={selectedCampaign}
              selectedJobType={selectedJobType}
              selectedBu={selectedBu}
              CampaignList={CampaignsList}
              serviceTitanJobTags={serviceTitanJobTags}
              tagIds={tagIds}
              setTagIds={setTagIds}
              setSelectedBu={setSelectedBu}
              setSelectedJobType={setSelectedJobType}
              setSelectedCampaign={setSelectedCampaign}
              filterOption={filterOption}
              provider={organizationData?.organization_provider || "ST"}
              urlMode={urlMode}
            />
          </Panel>
          <Panel header="Step 3: Thank You Page" key="3">
            <Step3Panel
              thankYouPage={thankYouPage}
              setThankYouPage={setThankYouPage}
            />
          </Panel>
          <CustomCssTransition
            in={urlMode === "job_booking"}
            timeout={300}
            classNames="glimpse"
            unmountOnExit
          >
            <Panel header="Step 4: Questions" key="4">
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {urlQuestions.map((qa, idx) => (
                <div key={idx} style={{ marginBottom: 16 }}>

                  <div style={{ 
                    display: "flex", 
                    alignItems: "center", 
                    gap: 8,
                    marginBottom: 8
                  }}>
                    <span style={{ 
                      fontSize: "14px", 
                      fontWeight: "600", 
                      color: "#333" 
                    }}>
                      Question {idx + 1}
                    </span>
                    <Button 
                      type="text" 
                      size="small"
                      icon={<CloseOutlined />}
                      onClick={() => setUrlQuestions((prev) => prev.filter((_, i) => i !== idx))}
                    />
                  </div>
                  <Input
                    placeholder={`Enter question ${idx + 1}`}
                    showCount
                    maxLength={100}
                    value={qa.question}
                    onChange={(e) => {
                      const value = e.target.value;
                      setUrlQuestions((prev) => prev.map((item, i) => i === idx ? { ...item, question: value } : item));
                    }}
                    style={{ 
                      fontSize: "15px",
                      marginBottom: 12
                    }}
                  />

                  {/* Simple Indented Answers */}
                  <div style={{ 
                    marginLeft: "8px",
                    marginBottom: 16 
                  }}>
                    {(qa.options || []).map((opt, optIdx) => (
                      <div key={optIdx} style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        gap: 8,
                        marginBottom: 8
                      }}>
                        {/* Inline gray arrow beside each answer */}
                        <span style={{
                          color: "#999999",
                          fontSize: "14px",
                          minWidth: "16px"
                        }}>
                          ↳
                        </span>
                        <Input
                          placeholder={`Answer ${optIdx + 1}`}
                          showCount
                          maxLength={50}
                          value={opt.option}
                          onChange={(e) => {
                            const value = e.target.value;
                            setUrlQuestions((prev) => prev.map((q, i) => {
                              if (i !== idx) return q;
                              const updated = [...(q.options || [])];
                              updated[optIdx] = { option: value };
                              return { ...q, options: updated };
                            }));
                          }}
                          style={{ 
                            fontSize: "14px",
                            width: "70%"
                          }}
                        />
                        <Button 
                          type="text" 
                          size="small"
                          icon={<CloseOutlined />}
                          onClick={() => {
                            setUrlQuestions((prev) => prev.map((q, i) => {
                              if (i !== idx) return q;
                              const updated = (q.options || []).filter((_, j) => j !== optIdx);
                              return { ...q, options: updated };
                            }));
                          }}
                        />
                      </div>
                    ))}
                    
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontSize: 12, color: "#6b7280" }}>
                        {(qa.options || []).length}/{MAX_ALLOWED_ANSWERS} answers (min 2, max {MAX_ALLOWED_ANSWERS})
                      </span>
                      <Button
                        type="dashed"
                        size="small"
                        onClick={() => setUrlQuestions((prev) => prev.map((q, i) => i === idx ? { ...q, options: [...(q.options || []), { option: "" }] } : q))}
                        disabled={(qa.options || []).length >= MAX_ALLOWED_ANSWERS}
                      >
                        + Add Answer
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, color: "#6b7280" }}>
                  {urlQuestions.length}/{MAX_ALLOWED_QUESTIONS} questions
                </span>
                <Button
                  type="dashed"
                  onClick={() => setUrlQuestions((prev) => [...prev, { question: "", options: [] }])}
                  disabled={urlQuestions.length >= MAX_ALLOWED_QUESTIONS}
                >
                  + Add Question
                </Button>
              </div>
            </div>
          </Panel>
          </CustomCssTransition>
          <Panel header={`Step ${urlMode === "job_booking" ? 5 : 4}: Booking Flow Options`} key="5">
            <Step2Panel
              customerType={customerType}
              campaignName={campaignName}
              isdispatchFee={isdispatchFee}
              isMemberFee={isMemberFee}
              additionalInfo={additionalInfo}
              dispatchDetails={dispatchDetails}
              provider={provider}
              showDispatchFee={urlMode === "job_booking"}
              setCustomerType={setCustomerType}
              setCampaignName={setCampaignName}
              setAdditionalInfo={setAdditionalInfo}
              setIsDispatchFee={setIsDispatchFee}
              handleDispatchTextChange={handleDispatchTextChange}
            />
          </Panel>
        </Collapse>
      </Modal>
    </>
  );
}
